<template>
  <div class="container-lg">
    <div class="compare">
      <!-- Loading State -->
      <div v-if="loading" class="loader"></div>

      <!-- Compare Table -->
      <div v-else-if="!isEmptyCompareProducts" class="table-wrapper">
        <table class="compare-table">
          <thead>
          <tr>
            <td></td>
            <td v-for="(product, index) in comparisonData.products" :key="index">
              <div class="product product--compare">
                <div class="product__preview">

                  <picture>
                    <source :srcset="product.image.webp" type="image/webp" />
                    <img
                        :alt="product.title"
                        :data-src="product.image.source"
                        width="100"
                        height="100"
                        class="product__image lazyload"
                        loading="lazy"
                    />
                  </picture>
                  <button :title="in18['page_remove_product_btn']" class="product__delete" type="button"
                          @click="removeProductFromCompareList(product)">
                    <img alt="" src="/shop/images/compare-delete.svg">
                  </button>
                </div>
                <div class="text-center">
                  <h3 class="line-clamp-2 text-[14px] font-medium leading-[18px] flex-1">
                    <a class="line-clamp-2" :href="product.link" :title="product.title">{{ product.title }}</a>
                  </h3>
                  <product-price :class-name="'product__price'" :prices="product.prices"></product-price>
                </div>
              </div>
            </td>
          </tr>
          </thead>
          <tbody>
          <template v-for="(attributes, attributeName) in comparisonData.attributes" :key="attributeName">
            <tr>
              <td>{{ attributeName }}</td>
              <td v-for="product in comparisonData.products" :key="product.id" class="col">
                {{ attributes[product.id] }}
              </td>
            </tr>
          </template>
          </tbody>
        </table>
      </div>

      <!-- Empty State -->
      <div v-else class="mt-5">
        <div class="section">
          <div class="text-center mb-5">
            <h1 class="section__title section__title--lg">
              {{ in18['system_compare_empty'] }}
            </h1>
            <div class="section__text">
              {{ in18['system_compare_empty_description'] }}
            </div>
            <div class="section__text mt-5">
              <a :title="in18['page_return_home']" class="btn btn--green btn--sm" href="/">
                {{ in18['page_return_home'] }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div><!-- /.compare -->
  </div><!-- /.container -->
</template>

<script>
import axios from 'axios';
import AddToCartButton from "../components/product/AddToCartButton.vue";

export default {
  name:       "CompareProducts",
  components: {
    "add-to-cart-button": AddToCartButton,
  },
  data() {
    return {
      comparisonData: {
        attributes: {},
        products:   []
      },
      loading:        true, // New loading state
    };
  },
  props:    ["in18"],
  computed: {
    comparedProducts: {
      get() {
        return this.$store.getters.comparedProducts;
      },
      set(value) {
        this.$store.commit("REMOVE_COMPARED_PRODUCTS", value);
      },
    },
    isEmptyCompareProducts() {
      return this.comparisonData.products.length === 0;
    },
  },
  created() {
    this.fetchProducts();
  },
  methods: {
    fetchProducts() {

      this.loading = true;

      axios.post('/api/product-compare', {product_compare: this.comparedProducts})
          .then((response) => {
            // Assign properties explicitly to maintain reactivity
            this.comparisonData.products = response.data.products || [];
            this.comparisonData.attributes = response.data.attributes || {};
          })
          .catch((error) => {
            window.toastr.error(error.response?.data?.message || "Error fetching products");
          })
          .finally(() => {
            this.loading = false;
          })
    },

    removeProductFromCompareList(product) {
      this.comparedProducts = product.id;
      this.fetchProducts();
    },
  },
};
</script>
